import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function truncateText(text, maxLength = 7) {
  if (!text || text.length <= maxLength) {
    return text;
  }
  return text.substring(0, maxLength) + '...';
}

export function isValidUrl(url) {
    if (!url || typeof url !== 'string') {
        return false;
    }

    try {
        // If no protocol is provided, prepend https:// for validation
        const urlToTest = url.includes('://') ? url : `https://${url}`;
        new URL(urlToTest);
        return true;
    } catch (e) {
        return false;
    }
}